// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2d9UX","top":"styles_top__1ZbTo"};